import React, { FC } from 'react';
import _find from 'lodash/find';
import FormikSimpleCheckbox from '@minecraft.formik-simple-checkbox';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts } from '@minecraft.drawer';
import { FilterData, WillingToEnum } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';

type Props = {
  willingToChange: FilterData;
  hairStyle: FilterData;
};

const HairStyle: FC<Props> = ({ willingToChange, hairStyle }) => {
  const { isSearching, shouldCategoryFilterBeVisible, getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.hairLengthStyle
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const willingToChangeCount =
    _find(filtersCounts?.[FiltersCountNameEnum.willingnessIds], {
      key: WillingToEnum.hairStyle,
    })?.docCount || 0;

  return (
    <>
      {isSearching && <Label>{hairStyle.label}</Label>}
      {shouldCategoryFilterBeVisible(willingToChange.name) && (
        <FormikSimpleCheckbox name={willingToChange.name} label={willingToChange.label} count={willingToChangeCount} />
      )}
      {shouldCategoryFilterBeVisible(hairStyle.name) && (
        <CheckboxListWithSearch
          withFormik
          withSelectAll
          name={hairStyle.name}
          options={getMatchedSearchOptions(hairStyle.name)}
        />
      )}
    </>
  );
};

export default HairStyle;
